import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const filterAndSortCourses = (courses) => {
  courses = courses.map(c => {
    const events = c.events.filter(({ starts_at }) => new Date(starts_at) > new Date());
    events.sort((a, b) => {
      const aDate = new Date(a.starts_at);
      const bDate = new Date(b.starts_at);
      if (aDate < bDate) {
        return -1;
      }
      if (aDate > bDate) {
        return 1;
      }
      return 0;
    });
    c.events = events;
    return c;
  });
  courses.sort((a, b) => {
    if (a.events.length === 0) {
      if (b.events.length === 0) {
        return 0;
      }
      return 1;
    }
    if (b.events.length === 0) {
      return -1;
    }
    const aDate = new Date(a.events[0].starts_at);
    const bDate = new Date(b.events[0].starts_at);
    if (aDate < bDate) {
      return -1;
    }
    if (aDate > bDate) {
      return 1;
    }
    return 0;
  });
  return courses;
};

export default new Vuex.Store({
  state: {
    courses: [],
    loadingEvents: true,
  },
  mutations: {
    setCourses(state, courses) {
      state.courses = courses;
    },
    setLoading(state, loading) {
      state.loadingEvents = loading;
    },
  },
  actions: {
    async fetchCourses(context, { tags, unitIds, nonce }) {
      unitIds = typeof unitIds == 'number' || typeof unitIds == 'string' ? [unitIds] : unitIds;
      let courses;
      if (unitIds.length > 1) {
        const response = await Promise.all(
          unitIds.map((id) => {
            const formData = new FormData();
            formData.append( 'action', 'get_courses' );
            formData.append( 'nonce', nonce );
            formData.append( 'unitId', id );
            return fetch( wpAjaxUrl, { method: 'POST', body: formData } )
              .then(res => res.text())
              .then(body => JSON.parse(body))
          })
        );
        courses = [].concat(...response);
        context.commit('setCourses', filterAndSortCourses(courses));
      } else {
        const formData = new FormData();
        formData.append( 'action', 'get_courses' );
        formData.append( 'nonce', nonce );
        formData.append( 'unitId', unitIds[0] );
        formData.append( 'tag', tags );

        fetch( wpAjaxUrl, { method: 'POST', body: formData })
          .then(res => res.text())
          .then(body => JSON.parse(body))
          .then(body => filterAndSortCourses(body))
          .then(c => context.commit('setCourses', c));
      }
    },
    async fetchEvents(context, courseIds) {
      const response = await fetch(`https://api.osufst.org/v2/fstdb/events?course_id=[${courseIds.join()}]&allows_online_listing=1&is_cancelled=false`);
      const data = await response.json();

      const events = data.filter(({ ends_at }) => new Date(ends_at) > new Date());
      events.sort((a, b) => {
        const aDate = new Date(a.starts_at);
        const bDate = new Date(b.starts_at);
        if (aDate < bDate) {
          return -1;
        }
        if (aDate > bDate) {
          return 1;
        }
        return 0;
      });

      await events.forEach(async e => {
        context.dispatch('fetchRegistrations', e);
      });

      const courses = JSON.parse(JSON.stringify(context.state.courses));
      courses.forEach(c => {
        c.events = events.filter(e => e.course_id === c.id);
      });
      courses.sort((a, b) => {
        if (a.events.length === 0) {
          if (b.events.length === 0) {
            return 0;
          }
          return 1;
        }
        if (b.events.length === 0) {
          return -1;
        }
        const aDate = new Date(a.events[0].starts_at);
        const bDate = new Date(b.events[0].starts_at);
        if (aDate < bDate) {
          return -1;
        }
        if (aDate > bDate) {
          return 1;
        }
        return 0;
      });
      context.commit('setCourses', courses);
      context.commit('setLoading', false);
    },
    async fetchRegistrations(context, event) {
      const res = await fetch(`https://api.osufst.org/v2/fstdb/events/${event.id}/registrations`);
      const registrations = await res.json();

      const courses = JSON.parse(JSON.stringify(context.state.courses));
      const course = courses.find(c => c.id === event.course_id);
      const evt = course.events.find(e => e.id === event.id);
      evt.registrations = registrations;
      context.commit('setCourses', courses);
    },
  },
  modules: {
  },
});
